import { editorDomainMetaOn } from "./constants";
import type { EditorDomainMetaName } from "./types";

export const editorDomainMetaIsOn = (name: EditorDomainMetaName): boolean =>
  document.querySelector(`meta[name='${name}']`)?.getAttribute("content") === editorDomainMetaOn;
